import request from 'request'
import i18n from './i18n'
import toast from './toast'

export default ({method = 'get', url,  query = {}, params, headers}) => {
  let req = request(method, url)
  // let csrf_token = q('meta[name="csrf-token"]', document).getAttribute('content')

  req.accept('json').type('json')
  req.query(query)
  if (params) req.send(params)

  if (headers) {
    for (let key in headers) {
      req.set(key, headers[key])
    }
  }
  let promise = new Promise((resolve, reject) => {
    req.end(res => {
      if (res.body.code) {
        let key = `code-${res.body.code}`
        if (i18n(key)) {
          return showError(i18n(key), reject)
        }
      }
      if (res.body && res.body.errors) {
        return showError(formatError(res.body.errors), reject)
      }
      if (res.body && res.body.error) {
        return showError(res.body.error, reject)
      }
      if (res.ok) return resolve(res.body)

      if (res.status) {
        return showError(`Server error ${res.status}`, reject)
      }
      return showError('No response', reject)
    })
  })

  function showError(msg, reject) {
    toast(msg, {type: 'error'})
    //window.scrollTo(0, 0)
    reject(new Error(msg))
  }

  function formatError(errors) {
    if (typeof errors === 'string') return errors
    let arr = []
    for (let k in errors) {
      arr.push(errors[k])
    }
    return arr.join('<br>')
  }

  return promise
}
